import PropTypes from 'prop-types';
import hotel from './hotel';

const hotelsPropTypes = PropTypes.arrayOf(hotel);

export default hotelsPropTypes;
